/*
 * ---------------------------------------------------------------------
 * imports
 * ---------------------------------------------------------------------
 */

import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
    ListItemIcon,
    ListItem,
    ListItemText,
    MenuItem,
    Icon,
    Divider,
    CircularProgress
} from "@material-ui/core";

import EditIcon from '@material-ui/icons/Edit';
import SecurityIcon from '@material-ui/icons/Security';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';

import {
    Translate
} from "src/shared_modules/i18n";


import { logout } from 'src/shared_modules/veu-visitors-core/actions/user';
import {
    closeChat,
    disposeChat
} from "src/shared_modules/veu-visitors-plazz/actions/chat";

import {
    showPopover,
} from 'src/shared_modules/veu-visitors-core/actions/popovers';

import { withMatomo } from 'src/shared_modules/veu-visitors-core/components/common/matomo-tracking';

import './account-menu.css';
/**
 * ---------------------------------------------------------------------
 * class
 * ---------------------------------------------------------------------
 * menu item list
 * can be included in AppBar and MobileMenu
 */
class UserMenuItems extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isBusy : false,
        }
    }

    componentDidMount() {
    }


    clickCancel() {
        this.setState({ isBusy: false });
    }

    async clickSend() {
        if( this.state.isBusy )
            return;

        this.props.closeChat();

        this.setState({
            isBusy: true,
        });
        await this.props.logout();
        this.props.trackEvent("logout","success","local");

        this.props.disposeChat();
        // there is no difference between error or success
        // always hide the popover
        if( this.props.closeHandler )
            this.props.closeHandler();
    }

    clickProfile() {
        this.props.closeChat();
        this.props.showPopover("Profile",{ openInUserTabContainer : true });

        if( this.props.closeHandler )
            this.props.closeHandler();
    }

    clickPrivacy() {
        this.props.closeChat();
        this.props.showPopover("Privacy",{ openInUserTabContainer : true });

        if( this.props.closeHandler )
            this.props.closeHandler();
    }

    clickAccount() {
        this.props.closeChat();
        this.props.showPopover("Account",{ openInUserTabContainer : true });

        if( this.props.closeHandler )
            this.props.closeHandler();
    }

    renderMobile() {

        //background: url("/visitor/assets/logout.png")
        let icon={
            backgroundImage: `url("${process.env.PUBLIC_URL}/assets/logout.png")`
        }
        let isWechat = false;
        if( this.props.user.type === "wechatanonym" )
            isWechat = true;

        return (<React.Fragment>
                    <Divider/>
                    { !isWechat && <ListItem style={this.props.themedStyle} button className="main-nav-nested-inset1" onClick={() => this.clickProfile()} >
                        <ListItemIcon><EditIcon /></ListItemIcon>
                        <ListItemText primary={<Translate>user-menu.profile</Translate>} />
                    </ListItem> }
                    { !isWechat && this.props.hasPlazzConvention &&<ListItem style={this.props.themedStyle} button className="main-nav-nested-inset1" onClick={() => this.clickPrivacy()} >
                        <ListItemIcon>
                            <SecurityIcon/>
                        </ListItemIcon>
                        <ListItemText primary={<Translate>user-menu.privacy</Translate>} />
                    </ListItem> }
                    { !isWechat && <ListItem style={this.props.themedStyle} button className="main-nav-nested-inset1" onClick={() => this.clickAccount()} >
                        <ListItemIcon><AccountCircleIcon /></ListItemIcon>
                        <ListItemText primary={<Translate>user-menu.account</Translate>} />
                    </ListItem> }
                    <Divider/>
                    <ListItem style={this.props.themedStyle} button className="main-nav-nested-inset1" onClick={() => this.clickSend()} >
                        <ListItemIcon>
                            { !this.state.isBusy && <Icon className="app-logout-icon" style={icon} /> }
                            { this.state.isBusy && <CircularProgress className="logout" size={20} /> }
                        </ListItemIcon>
                        <ListItemText primary={<Translate>user-menu.logout</Translate>} />
                    </ListItem>
            </React.Fragment>);

    }

    renderDesktop() {
        //background: url("/visitor/assets/logout.png")
        let icon={
            backgroundImage: `url("${process.env.PUBLIC_URL}/assets/logout.png")`
        }
        let isWechat = false;
        if( this.props.user.type === "wechatanonym" )
            isWechat = true;

        return (<React.Fragment>
                    { !isWechat && <MenuItem style={this.props.themedStyle}  onClick={() => this.clickProfile()} >
                        <ListItemIcon>
                            <EditIcon/>
                        </ListItemIcon>
                        <Translate>user-menu.profile</Translate>
                    </MenuItem> }
                    { !isWechat && this.props.hasPlazzConvention && <MenuItem style={this.props.themedStyle} onClick={() => this.clickPrivacy()} >
                        <ListItemIcon>
                            <SecurityIcon/>
                        </ListItemIcon>
                        <Translate>user-menu.privacy</Translate>
                    </MenuItem> }
                    { !isWechat && <MenuItem style={this.props.themedStyle} onClick={() => this.clickAccount()} >
                        <ListItemIcon>
                            <AccountCircleIcon/>
                        </ListItemIcon>
                        <Translate>user-menu.account</Translate>
                    </MenuItem> }
                    <Divider/>
                    <MenuItem style={this.props.themedStyle} onClick={() => this.clickSend()} >
                        <ListItemIcon>
                            { !this.state.isBusy && <Icon className="app-logout-icon" style={icon} /> }
                            { this.state.isBusy && <CircularProgress className="logout" size={20} /> }
                        </ListItemIcon>
                        <Translate>user-menu.logout</Translate>
                    </MenuItem>
            </React.Fragment>);
    }

    render() {
        return (<React.Fragment>
                { this.props.mobile && this.renderMobile() }
                { !this.props.mobile && this.renderDesktop() }
            </React.Fragment>);
    }
}

/*
 * ---------------------------------------------------------------------
 * PopoverLogin Redux Container
 * ---------------------------------------------------------------------
 */
UserMenuItems.propTypes = {
    meaconfig: PropTypes.object,
    hasPlazzConvention: PropTypes.bool,
    user: PropTypes.object,
};

const mapStateToProps = ( state, ownProps ) => {
    return {
        meaconfig : state.plazz.mea.config,
        hasPlazzConvention : state.event.hasPlazzConvention,
        user : state.user,
    };
};

const mapDispatchToProps = {
    logout,
    closeChat,
    disposeChat,
    showPopover,
};

/*
 * ---------------------------------------------------------------------
 * Export the redux container
 * ---------------------------------------------------------------------
 */
export default connect(
        mapStateToProps,
        mapDispatchToProps,
        null,
        { forwardRef: true }
    )(withMatomo(UserMenuItems));
